import React from "react";
import loader from "../assets/media/loader/dual-ring.svg";
const Loader = () => {
  return (
    <div
      style={{
        height: "100vh",
        display: "flex",
        justifyContent: "center",
      }}
    >
      <img style={{ width: "50px" }} src={loader} alt="Loading..." />
    </div>
  );
};

export default Loader;
